import React from 'react';
import { Gauge, Percent, Crosshair, Activity, Newspaper, BellRing } from 'lucide-react';
import { SectionHead } from './SectionHead';

const FEATURES = [
  { icon: Gauge, title: 'A 0 to 100 score, calculated in code', desc: 'Built from momentum, trend, volume and volatility readings, plus options flow or mean-reversion inputs depending on the strategy you pick. The written analysis explains the numbers; it does not set them.' },
  { icon: Percent, title: 'Probabilities that say what they mean', desc: 'Each probability states exactly what it measures, for example the chance of closing above the entry price by the end of the horizon, estimated from recent drift and volatility.' },
  { icon: Crosshair, title: 'Entry, target and stop from volatility', desc: 'Levels come from the latest close and the 14-day average true range (ATR), with the risk-to-reward ratio shown next to them.' },
  { icon: Activity, title: 'Options flow with contract detail', desc: 'Large options trades with strike, expiry, premium and side, in card or list view, so you can see where premium is moving.' },
  { icon: Newspaper, title: 'A daily market snapshot', desc: 'A morning summary of index ETFs, Treasury yields, macro releases and headlines. Every number in the AI briefing is checked against the source data.' },
  { icon: BellRing, title: 'Watchlists and alerts', desc: 'Keep the tickers you follow in one list and get notified when the conditions you set are met.' },
];

export const Features = () => (
  <section className="mk-section" id="capabilities" aria-labelledby="capabilities-title">
    <div className="mk-container">
      <SectionHead id="capabilities-title" eyebrow="Product" title="What you see in every outlook" sub="One idea per tool. No black boxes: each number on screen has a stated source and definition." />
      <ul className="mk-feat-grid">
        {FEATURES.map((f) => (
          <li key={f.title} className="mk-card mk-feat" data-testid="feature-card">
            <span className="mk-feat-ic"><f.icon size={20} aria-hidden="true" /></span>
            <h3>{f.title}</h3>
            <p>{f.desc}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
